// extracted by mini-css-extract-plugin
export var addButton = "_nx-0";
export var border = "_nx-8";
export var check = "_nx-h";
export var danger = "_nx-6";
export var dropdownContainer = "_nx-1";
export var editModalBody = "_nx-j";
export var footerContainer = "_nx-i";
export var fullWidth = "_nx-a";
export var hide = "_nx-9";
export var icon = "_nx-3";
export var input = "_nx-7";
export var inputFlex = "_nx-b";
export var inputWrapper = "_nx-c";
export var manualFocus = "_nx-5";
export var optionButton = "_nx-4";
export var pillWrapper = "_nx-e";
export var pointer = "_nx-2";
export var showOverflow = "_nx-f";
export var tagsFlex = "_nx-d";
export var xButton = "_nx-g";